module.exports = __webpack_public_path__ + "img/03.29b9d6da.gif";